// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"bia-z"};